<template>
  <el-container class="adminMenu">
    <el-header>
      <el-row>
        <el-col :span="18">
          <div style="
              display: flex;
              justify-content: left;
              align-items: center;
              height: 100%;
            ">
            <p style="display: inline-block" class="text-4">
              <img v-if="$store.state.adminSetting.adst05" style="margin-top: -3px; height: 30px"
                :src="$store.state.adminSetting.adst05" />
              <img v-else style="margin-top: -3px; height: 30px" src="/xtlogo.png" />
              &nbsp;
              <span>|</span>
              {{ $store.state.adminSetting.adst03 || "BIM协同管理云平台" }}
            </p>
          </div>
        </el-col>
        <el-col :span="4" :offset="2" class="jb" style="color: #fff">
          <div class="right-menu">
            <!-- <i style="font-size: 21px; margin-right: 20px; cursor: pointer;color:rgb(45, 45, 45);"
              class="el-icon-question" @click="openHelp"></i> -->
            <el-dropdown class="avatar-container" trigger="click">
              <div class="avatar-wrapper">
                <img src="@/assets/img/chaoguan.png" class="user-avatar" />
                <span class="mar-left10" style="color: rgb(45, 45, 45)">超级管理员</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native.prevent="Updatepwd">
                  修改密码
                </el-dropdown-item>
                <el-dropdown-item @click.native.prevent="showPlatformManagement">
                  平台管理
                </el-dropdown-item>
                <el-dropdown-item @click.native="out">
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-container>

      <el-menu :default-active="defaultActive" :router="true" class="el-menu-vertical-demo" background-color="#2d2d2d"
        text-color="#ffffff" active-text-color="#EC8E00" :collapse="isCollapse">
        <el-menu-item @click="isCollapse = !isCollapse">
          <i class="el-icon-s-help"></i>
          <span slot="title">{{
            ($store.state.adminSetting.adst03 == null || $store.state.adminSetting.adst03 == '')
              ? "上海益埃毕"
              : $store.state.adminSetting.adst03
          }}</span>
        </el-menu-item>
        <el-menu-item class="textEllipsis" :index="'/' + item.path" v-for="(item, index) in menuData" :key="index"
          :route="item.path">
          <i :class="item.icon" v-if="!item.icon.includes('ktr-')"></i>
          <i class="icon iconfont" :class="item.icon" v-else></i>
          <span slot="title" :style="{ letterSpacing: isEn ? 'normal' : '' }" :title="item.authName">{{ item.authName
          }}</span>
        </el-menu-item>
      </el-menu>

      <el-main>
        <router-view v-if="viewShow" ref="view"></router-view>
      </el-main>
    </el-container>
    <el-dialog :close-on-click-modal="false" title="修改密码" :visible.sync="UpdatepwdDialog" width="32%" center>
      <el-form :model="updateform" class="paswd" :rules="rulespwd" ref="ruleForm">
        <el-form-item prop="oldpwd" label="旧密码" label-width="80px">
          <el-input v-model="updateform.oldpwd" type="password" autocomplete="off" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd" label="新密码" label-width="80px">
          <el-input v-model="updateform.newpwd" type="password" autocomplete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd1" label="确认密码" label-width="80px">
          <el-input v-model="updateform.newpwd1" type="password" autocomplete="off" placeholder="再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdatepwdDialog = false">取 消</el-button>
        <el-button type="primary" @click="UpdatepwdDialogBtn('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 平台管理 -->
    <el-dialog :close-on-click-modal="false" title="平台管理" :visible.sync="platformManagementIsShow" width="32%" center>
      <el-form :model="Platform" label-width="80px" ref="Platform" :rules="PlatformRules">
        <el-form-item label="平台简称" prop="adst02">
          <el-input v-model="Platform.adst02" auto-complete="off" placeholder="请输入平台简称"></el-input>
        </el-form-item>
        <el-form-item label="平台名称" prop="adst03">
          <el-input v-model="Platform.adst03" auto-complete="off" placeholder="请输入平台名称"></el-input>
        </el-form-item>
        <el-form-item label="平台备案" prop="adst04">
          <el-row class="padding0">
            <el-col :span="11">
              <el-input v-model="ptbaArr.record1Link" auto-complete="off" placeholder="请输入平台备案第一行链接"></el-input>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-input v-model="ptbaArr.record1" auto-complete="off" placeholder="请输入平台备案第一行文字"></el-input>
            </el-col>
          </el-row>
          <el-row class="pad-mar">
            <el-col :span="11">
              <el-input v-model="ptbaArr.record2Link" auto-complete="off" placeholder="请输入平台备案第二行链接"></el-input>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-input v-model="ptbaArr.record2" auto-complete="off" placeholder="请输入平台备案第二行文字"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="平台Logo">
          <el-upload class="upload-demo" ref="upload" :action="action" :data="type" :multiple="false"
            :file-list="fileList" :auto-upload="false" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload" :headers="importHeaders">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button class="mar-left10" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="平台背景">
          <el-upload class="upload-demo" ref="upload2" :action="action" :multiple="false" :data="type"
            :file-list="fileList2" :auto-upload="false" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload2" :headers="importHeaders">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button class="mar-left10" size="small" type="success" @click="submitUpload2">上传到服务器</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="4" :offset="16">
          <el-button @click="ResetAdminSet" type="danger">重置</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="UpdateAdmin" type="primary">确定</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <help-center ref="helpcenter"></help-center>
  </el-container>
</template>

<script>
import {
  outLogin,
  GetadminsetList,
  Updateadminset,
  AdminUpdatePwd,
  ResetAdminSet,
} from "@/setAxios";
import personal from "../my/personal";

import helpCenter from "@/components/helpCenter";

export default {
  components: {
    personal,
    helpCenter,
  },
  name: "admin",
  data() {
    return {
      isEn: this.$i18n.locale == 'en',
      //平台备案
      ptbaArr: {
        record1: "",
        record1Link: "",
        record2: "",
        record2Link: "",
      },
      fileList: [],
      fileList2: [],
      action: this.$store.state.baseUrl + "/api/UpdateOrAddAdminSet ",
      importHeaders: { token: localStorage.getItem("token") },
      type: {
        type: 1,
      },
      platformManagementIsShow: false,
      Platform: { adst02: "", adst03: "", adst04: "" },
      viewShow: true,
      // 这里是修改密码对话框
      UpdatepwdDialog: false,
      updateform: {
        oldpwd: null,
        newpwd: null,
        newpwd1: null,
      },
      rulespwd: {
        newpwd1: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ],
        oldpwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newpwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "长度6位以上", trigger: "blur" },
        ],
      },
      PlatformRules: {
        adst02: [
          // { required: true, message: "请输入平台简称", trigger: "blur" },
          { max: 4, message: "长度必须小于4位", trigger: "blur" },
        ],
        adst03: [
          // { required: true, message: "请输入平台名称", trigger: "blur" },
          { max: 20, message: "长度必须小于20位", trigger: "blur" },
        ],
      },
      // 这里是上传头像
      imageUrl: "",
      // 这里是用户中心
      addForm: {},
      isTransition: true,
      defaultActive: null,
      isCollapse: true,
      personalCenter1: false,
      names: "",
      menuData: [
        {
          id: 1,
          authName: "用户管理",
          path: "adminUser",
          icon: "el-icon-s-custom",
        },
        {
          id: 2,
          authName: "企业管理",
          path: "adminEnterprise",
          icon: "el-icon-s-marketing",
        },
        {
          id: 3,
          authName: "模型管理",
          path: "modelManager",
          icon: "el-icon-s-tools",
        },
        {
          id: 4,
          authName: "登录日志",
          path: "loginInfo",
          icon: "el-icon-s-operation",
        },
        // {
        //   id: 5,
        //   authName: "公告管理",
        //   path: "adminAnnouncement",
        //   icon: "el-icon-message-solid",
        // },
        {
          id: 6,
          authName: "宣传管理",
          path: "adminPropaganda",
          icon: "el-icon-s-promotion",
        },

        {
          id: 7,
          authName: "企业大屏",
          path: "enterpriseDataView",
          icon: "el-icon-s-platform",
        },
        // {
        //   id: 8,
        //   authName: "操作手册维护",
        //   path: "enterpriseDataView",
        //   icon: "el-icon-s-order",
        //   children: [
        //     {
        //       id: 9,
        //       authName: "超管",
        //       path: "adminHelp",
        //       icon: "el-icon-s-promotion",
        //     },
        //     {
        //       id: 10,
        //       authName: "企管",
        //       path: "enterpriseHelp",
        //       icon: "el-icon-s-promotion",
        //     },
        //     {
        //       id: 11,
        //       authName: "项管",
        //       path: "projectHelp",
        //       icon: "el-icon-s-promotion",
        //     },
        //     {
        //       id: 12,
        //       authName: "用户",
        //       path: "userHelp",
        //       icon: "el-icon-s-promotion",
        //     },
        //     {
        //       id: 13,
        //       authName: "移动端",
        //       path: "mobileHelp",
        //       icon: "el-icon-s-promotion",
        //     },
        //   ],
        // },
        // {
        //   id:9,
        //   authName:'功能模板管理',
        //   path:'modelFunction',
        //   icon: "el-icon-s-operation",
        // }
      ],
    };
  },
  computed: {
    routerPath() {
      return this.$route.name;
    },
  },
  watch: {
    routerPath() {
      this.paths = this.$route.name;
    },
    $route: {
      handler: function (newRoute, oldRoute) {
        this.defaultActive = newRoute.path
      },
      // 深度观察监听
      deep: true
    },
  },
  mounted() {

  },
  methods: {
    openHelp() {
      this.$refs.helpcenter.open();
    },
    ResetAdminSet() {
      this.$confirm("确定重置平台设置？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ResetAdminSet().then((res) => {
          this.$message({
            type: "success",
            message: "重置成功",
          });
          this.ptbaArr = {
            record1: "",
            record1Link: "",
            record2: "",
            record2Link: "",
          };
          this.$store.state.adminSetting.isHave = false;
          this.initAdmin();
        });
      });
    },
    async initAdmin() {
      let res = await GetadminsetList();
      if (res.Data) {
        this.Platform = res.Data;
        if (res.Data.adst02) {
          this.$store.state.adminSetting.adst02 = res.Data.adst02;
        }
        if (res.Data.adst03) {
          this.$store.state.adminSetting.adst03 = res.Data.adst03;
        }
        if (res.Data.adst05) {
          this.$store.state.adminSetting.adst05 =
            this.$store.state.baseUrl + res.Data.adst05;
        } else {
          this.$store.state.adminSetting.adst05 = "";
        }
      } else {
        this.Platform = { adst02: "", adst03: "", adst04: "" };
        this.$store.state.adminSetting.adst02 = "";
        this.$store.state.adminSetting.adst03 = "";
        this.$store.state.adminSetting.adst05 = "";
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    submitUpload2() {
      this.$refs.upload2.submit();
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.Code == 1) {
        this.$store.state.adminSetting.isHave = false;
        this.$message({
          type: "success",
          message: "修改成功",
        });
      }
    },
    beforeAvatarUpload(file) {
      this.type.type = 1;
      let fd = new FormData();
      fd.append("file", file);
      fd.append("type", this.type);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "png" || suffix === "jpg" || suffix === "bmp" || suffix === "tif" || suffix === "webp" || suffix === "jpeg"
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M
    },
    beforeAvatarUpload2(file) {
      this.type.type = 2;
      let fd = new FormData();
      fd.append("file", file);
      fd.append("type", this.type);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "png" || suffix === "jpg" || suffix === "bmp" || suffix === "tif" || suffix === "webp" || suffix === "jpeg"
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M
    },
    async showPlatformManagement() {
      this.platformManagementIsShow = true;
      // 获取值
      let res = await GetadminsetList();
      if (res.Data) {
        this.Platform = res.Data;
        if (res.Data.adst04) {
          this.ptbaArr = JSON.parse(res.Data.adst04);
        }
      }
    },
    UpdateAdmin() {
      var _this = this;
      this.$refs["Platform"].validate((valid) => {
        if (valid) {
          let text = "";
          if (
            _this.ptbaArr.record1 != "" ||
            _this.ptbaArr.record1Link != "" ||
            _this.ptbaArr.record2 != "" ||
            _this.ptbaArr.record2Link != ""
          ) {
            if (
              _this.ptbaArr.record1 &&
              _this.ptbaArr.record1Link &&
              _this.ptbaArr.record2 &&
              _this.ptbaArr.record2Link
            ) {
              text = JSON.stringify(_this.ptbaArr);
            } else {
              _this.$message({
                type: "warning",
                message: "平台备案请填写完整",
              });
              return;
            }
          }
          let params = {
            title: _this.Platform.adst02,
            name: _this.Platform.adst03,
            text: text,
          };
          Updateadminset(params).then((res) => {
            if (res.Code == 1) {
              _this.$message({
                type: "success",
                message: "修改成功",
              });
              _this.$store.state.adminSetting.isHave = false;
              _this.initAdmin();
              _this.platformManagementIsShow = false;
            }
          });
        }
      });
    },
    getDataUser() {
      // let id = localStorage.getItem("id");
      // GetUserInfo({ id }).then((res) => {
      //   //(res);
      // });
    },
    out() {
      outLogin().then((res) => {
        if (res.Code == 1) {
          this.$store.state.isClickProject = false;
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          localStorage.clear();
          localStorage.setItem("isLogin", false);
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    // 这里是个人中心
    personalCenter() {
      this.personalCenter1 = true;
    },
    // 这里是修改密码
    Updatepwd() {
      // this.updateform = this.$options.data().updateform;
      this.UpdatepwdDialog = true;
    },
    // 这里是修改密码确定按钮
    UpdatepwdDialogBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.updateform.newpwd != this.updateform.newpwd1) {
            this.$message.error("确认密码输入不正确");
            return;
          }
          let old = this.updateform.oldpwd;
          let news = this.updateform.newpwd;
          let id = localStorage.getItem("id");
          AdminUpdatePwd({ oldpwd: old, pwd: news, uid: id }).then((res) => {
            //(res, "res");
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "密码修改成功",
              });
            } else {
              this.$message.error("旧密码不正确");
            }
          });
          this.UpdatepwdDialog = false;
        } else {
          //("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    this.defaultActive = this.$route.path
    this.paths = this.$route.fullPath.substr(1);
    this.initAdmin();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-submenu__icon-arrow,
.el-icon-arrow-down {
  line-height: 19px;
}



.el-main {
  background-color: #f4f4f5;
}

/* 新增 */
.el-aside2 {
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}

.font {
  font-size: 18px;
  font-weight: 600;
}

.pad-t-b {
  padding: 0 40px 0 20px;
}

.text-4 {
  font-weight: 700;
  font-style: normal;
  // color: #0092d9;
  color: #2f2f2f;
  margin-left: 4px;
  font-size: 20px;
  text-align: left;
  letter-spacing: 2px;
}

.margin0 {
  margin: 0;
}

.gr-span {
  display: block;
  width: 100%;
  height: 100%;
}

.dis-bok {
  display: block;
}

.paswd {
  width: 90%;
  margin: 0 auto;
}

.padding0 {
  padding: 0;
}

.pad-mar {
  padding: 0px;
  margin-top: 20px;
}

.mar-left10 {
  margin-left: 10px;
}

.el-menu-vertical-demo {
  height: 100%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 187px;
  height: 100%;
}

.el-menu-item i {
  color: #ffffff;
}
</style>

<style lang="less" scoped>
/deep/ .el-menu-item i {
  // margin-right: 20px;

}

/deep/.el-menu-item span {
  text-align: center;
}

.img-one {
  width: 40px;
  height: 40px;
  border-radius: 2px;
  margin-left: 3px;
}

.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

/deep/ .view {
  overflow: auto;
}

.title-left {
  margin-left: 22px;
}

.menu-left {
  margin-right: 30px;
  width: 100%;
}

.el-container {
  width: 100%;
  height: 100%;
}

.el-header {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0px;

  .el-col-1 {
    margin-left: 30px;

    img {
      height: 60px;
    }
  }

  .el-col-15 {
    font-weight: 700;
    font-style: normal;
    color: #000000;
    font-size: 28px;
  }
}

.el-aside {
  background-color: #bfcbd9;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-aside2 {
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}

.view {
  background-color: #f4f4f5;
  width: 100%;
  height: 100%;
  padding: 20px;
  // box-sizing: border-box;
  // color: #333;
}

.breadcrumb-container {
  float: left;
}

.right-menu {
  float: right;
  width: 100%;
  height: 60px;
  // line-height: 50px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.1s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  /deep/ .el-icon-s-order {
    margin-right: 20px !important;
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      position: relative;
      height: 45px;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

/deep/.el-dropdown-menu__item {
  color: black;
  background: #fff;

  &:hover {
    color: #ffbb37;
    background-color: black;
  }
}

/deep/ .el-dropdown-menu,
.el-popper,
.el-dropdown-menu--small {
  background-color: white !important;
}

/deep/ .popper__arrow::after {
  border-bottom-color: #FFFFFF !important;
}


/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: white !important;
  }
}

.bg-cor {
  background-color: #f4f4f5 !important;
  overflow: hidden;
}

.jb {
  // background: linear-gradient(to right, #4f6dfa, #5aa6f9);
  //background: linear-gradient(to right, #2f2f2f, #535353);
  background: white;
  height: 60px;
}

.el-icon-s-promotion:before {
  content: "\E7BA";
  color: #fff;
}
</style>
